import { DragDropContext } from "react-dnd";
import HTML5Backend  from "react-dnd-html5-backend";

//Make this a singleton so there is no error after hot-reload
const Html5DragDropContext = DragDropContext(HTML5Backend);

export default Html5DragDropContext;
